<ol class="inspections" style="counter-set: item 0">
  <li
    class="section"
    *ngFor="
      let item of inspection?.testData | filterBy : ['isApplicable'] : true
    "
  >
    <div class="block">
      <span class="inspection-item">בדיקת אופין רשת מים:</span>
      <strong style="display: table-cell; padding-right: 5px">
        {{ item.type }}
      </strong>

      <table
        class="data-table"
        style="page-break-inside: avoid; margin-top: 10px"
      >
        <thead>
          <tr>
            <th style="width: 33%"><span>שם הבודק</span></th>
            <th style="width: 33%"><span>תאריך הבדיקה</span></th>
            <th style="width: 33%"><span>שעת הבדיקה</span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span>{{ item.testerName }}</span>
            </td>
            <td>
              <span>{{ inspectionDate | date : 'shortDate' : 'GMT+3' }}</span>
            </td>
            <td>
              <span>{{ item.testDateTime }}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <table
        class="data-table"
        style="page-break-inside: avoid; margin-top: 20px"
      >
        <tbody>
          <tr>
            <td style="background-color: #ecf0f1; width: 33.3%">
              <span>מיקום מדידת לחצים</span>
            </td>
            <td>
              <span>{{ item.pressureMeasurementLocation }}</span>
            </td>
          </tr>
          <tr>
            <td style="background-color: #ecf0f1">
              <span>מיקום מדידת ספיקה</span>
            </td>
            <td>
              <span> {{ item.flowMeasurementLocation }}</span>
            </td>
          </tr>
          <tr>
            <td style="background-color: #ecf0f1">
              <span>קוטר צינור אספקת מים</span>
            </td>
            <td>
              <span> {{ item.waterSupplyPipeDiameter }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <authority-labs-water-supply-chart
      class="certificate-section"
      [staticPressure]="item.staticPressure"
      [residualPressure]="item.residualPressure"
      [totalFlow]="item.flowRate"
      [systemFlow]="item.systemFlow"
      [systemDemand]="item.systemDemand"
    ></authority-labs-water-supply-chart>

    <ol class="notes" style="page-break-inside: avoid; margin-top: 10px">
      <li *ngFor="let note of item.notes">
        <strong>{{ note.notes }}</strong>
      </li>
    </ol>
  </li>
  <li
    *ngIf="notes.length > 0"
    style="page-break-inside: avoid; margin-top: 20px"
  >
    <span class="inspection-item">הערות נוספות על ידי המעבדה:</span>
    <ol class="notes">
      <li *ngFor="let note of notes">
        <strong>{{ note }}</strong>
      </li>
    </ol>
  </li>
</ol>
